import { type HTMLAttributes } from "react";
import { cn } from "./cn";

const SOFT = {
  neutral: "bg-muted text-muted-foreground",
  primary: "bg-primary-muted text-primary-muted-foreground",
  success: "bg-success-muted text-success-muted-foreground",
  warning: "bg-warning-muted text-warning-muted-foreground",
  destructive: "bg-destructive-muted text-destructive-muted-foreground",
} as const;

const SOLID = {
  neutral: "bg-foreground text-background",
  primary: "bg-primary text-primary-foreground",
  success: "bg-success text-success-foreground",
  warning: "bg-warning text-warning-foreground",
  destructive: "bg-destructive text-destructive-foreground",
} as const;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Semantic colour. */
  tone?: keyof typeof SOFT;
  /** `soft` = tinted background (default), `solid` = filled. */
  variant?: "soft" | "solid";
}

/** Compact status / label pill. */
export function Badge({
  tone = "neutral",
  variant = "soft",
  className,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        variant === "solid" ? SOLID[tone] : SOFT[tone],
        className,
      )}
      {...props}
    />
  );
}
